// Unpublished Work © 2023 Deere & Company.

import t from 'tcomb';
import {PageStatus} from '../page-status';
import {IndividualNameLogs} from './individual-name-logs';
import {AddressLogs} from './address-logs';
import {TaxIdLogs} from './tax-id-logs';
import {MergeLogs} from './merge-logs';
import {BusinessToContLogs} from './business-to-contact-logs';
import {PhoneFaxLogs} from './phone-fax-logs';
import {EmailLogs} from './email-logs';
import {CustomerConsentLogs} from './customer-consent-logs';
import {SurvivorConsentLogs} from './survivor-consent-logs';
import {BusinessNameLogs} from './business-name-logs';
import {EntityLogs} from './entity-logs';
import {BusinessContactLogs} from './business-contact-logs';

export const LogHistory = t.struct({
    addressLogs: t.list(AddressLogs),
    taxIdLogs: t.list(TaxIdLogs),
    mergeLogs: t.list(MergeLogs),
    busnToContLogs: t.list(BusinessToContLogs),
    phoneFaxLogs: t.list(PhoneFaxLogs),
    emailLogs: t.list(EmailLogs),
    customerConsentLogs: t.list(CustomerConsentLogs),
    survivorConsentLogs: t.list(SurvivorConsentLogs),
    individualNameLogs: t.list(IndividualNameLogs),
    businessNameLogs: t.list(BusinessNameLogs),
    entityLogs: t.list(EntityLogs),
    businessContactLogs: t.list(BusinessContactLogs),
    customerName: t.String,
    customerType: t.String,
    logHistoryStatus: PageStatus
}, {
    defaultProps: {
        addressLogs: [],
        taxIdLogs: [],
        mergeLogs: [],
        busnToContLogs: [],
        phoneFaxLogs: [],
        emailLogs: [],
        customerConsentLogs: [],
        survivorConsentLogs: [],
        individualNameLogs: [],
        businessNameLogs: [],
        entityLogs: [],
        businessContactLogs: [],
        customerName: '',
        customerType: '',
        logHistoryStatus: PageStatus.meta.map.COMPLETE
    },
    name: 'LogHistory',
    strict: true
});
